<template>
  <div class="meniu_produse">
    <section class="container_sectiune_meniu" >
      <div class="containerg sectiune1">
      </div>
      <div class="containerg meniu_produse2">
      <div class="categorii_flex">
        <div class="slic_vue slic_bucatarie">
          <swiper ref="mySwiper" :options="swiperOptions" >
              <swiper-slide v-for="categorie in categorii" :key="categorie.id"  class="box_categorie nume_categorie_swiper"><div @click="mergiLaCategorie('id'+categorie.id)">{{categorie.name}}</div></swiper-slide>
              
            </swiper>
            <div class="prev-next">
                <div class="prev_class prev_next_class" slot="button-prev"><i class="ri-arrow-left-s-line "></i></div>
                <div class="next_class prev_next_class" slot="button-next"><i class="ri-arrow-right-s-line"></i></div>
              </div>
          </div>
          
        </div>
    </div>
    </section>

    <section class="sectiune_mobile containerg meniu_produse_search"> 
      <form action="/search">
       <div class="search_relative ">
        <input class="search_header_mobile" type="search" name='search' placeholder="Search food.."/>
         <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'search' }" class="icon_search"/>
       </div>
       </form>
    </section>
    <section class="container_sectiune_categorii_produse meniu_produse containerg">
      <div v-for="categorie in categorii" :key="categorie.id" :class="'padding_text_container produse-id'+categorie.id">
        <div class="text_container" v-if="$i18n.locale == 'ro'">
          {{categorie.name}}
        </div>
        <div class="text_container" v-else>
          {{categorie.name}}
        </div>
        <div class="produse">
            <div :dataslug="produs.additional.slug_ro" v-for="produs in categorie.products.data" :key="produs.id" class="box_produs box_general box_gen_mob"  @click="deschidereModalProdus(produs.additional.slug_ro, $event)">
              <div class="positionrelative box_top">
                 <div v-if="$store.state.status_bucatarie == '2' && produs.preparing_time == 'Normal'" class="produs_indisponibil">
                  Indisponibil momentan
                </div>
                <div v-if="produs.main_image.length > 0">
                  <div v-for="imagine in produs.main_image.slice(0,1)" :key="imagine.thumbnailpath">
                    <img :src="imagine.thumbnailpath"/>
                  </div>
                </div>
                <div v-else>
                  <img src='@/assets/images/poza_default1.jpg' />
                </div>

                <i  v-if="filter(produs.id)" class="ri-heart-fill heart_absolute favorit element_desktop" :datastatus="0" :dataid="produs.id"></i>
                <i v-else class="ri-heart-line heart_absolute nefavorit element_desktop" :datastatus="1" :dataid="produs.id"></i>
              </div>
              <div class="box_bottom">
                
                <div class="titlu_box" v-if="$i18n.locale == 'ro'">
                  {{ produs.additional.name_ro }}
                </div>
                <div class="titlu_box" v-else>
                  {{ produs.additional.name_en }}
                </div>
                <div class="descriere_box" v-if="$i18n.locale == 'ro'">
                  {{produs.additional.description_ro | strippedContent}}
                </div>
                <div class="descriere_box" v-else>
                  {{produs.additional.description_en | strippedContent}}
                </div>
                
                </div>
                <div class="pret_cumpara">
                  <div class="pret_box" >{{ produs.price }} lei</div>
                  <div class="plus_produs"><i class="ri-add-line"></i></div>
                </div>   
            </div>
        </div>
      </div>
    </section>

   
  </div>

  
</template>



<script>
  //import VueSlickCarousel from 'vue-slick-carousel'
  //import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
 // import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import $ from 'jquery'
  import axios from 'axios';
  import Vue from 'vue';
  import Vuex from 'vuex';
  Vue.use(Vuex)

  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

  export default { 
    name: 'carrousel',
    metaInfo() {
        return {
            title: 'Bucătărie Tiki Bistro | Livrări și take-away | În fiecare zi',
            meta: [
                { name: 'description', content: 'Ești pasionat de bucătăria mexicană, asiatică, italiană, americană, libaneză? Descoperă toate preparatele Tiki Bistro.'},
                { property: 'og:title', content: 'Bucătărie Tiki Bistro | Livrări și take-away | În fiecare zi'},
                { property: 'og:site_name', content: 'Tiki Bistro'},
                { property: 'og:description', content: 'Ești pasionat de bucătăria mexicană, asiatică, italiană, americană, libaneză? Descoperă toate preparatele Tiki Bistro.'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'}   
            ]
        }
    },
    components: { 
      //VueSlickCarousel,
      Swiper,
      SwiperSlide  
    },
    methods: {
      showModal_produs(){
        this.$root.$refs.Header.showModal_header_produs();
      },
      replace_nume_bucatarie(nume) {
        return nume.replace(" ", "-"); 
      },
      deschidereModalProdus(slug,event) {
        this.produse_extra = []
        this.$root.$refs.Header.afisare_modal_produs(slug,event);
      },
       
      mergiLaCategorie(slug) {
        $("html, body").animate({ scrollTop: $('.produse-'+slug).offset().top -170 }, 300);
      },
      filter(id_produs){
        return this.$root.$refs.Header.filter(id_produs);
      },  
    },
    data() {
      return {
        swiperOptions: {
          spaceBetween: 30,
          slidesPerGroup: 1,
          loop: false,
          speed: 0,
          watchActiveIndex: true,
          slidesPerView: 6,
          slidesPerGroupSkip : 1,
          loopFillGroupWithBlank: true,
          navigation: {
            nextEl: '.next_class',
            prevEl: '.prev_class'
          },
          breakpoints: {       
              320: {       
                slidesPerView: 3,
                spaceBetween: 10     
              },          
              768: {       
                slidesPerView: 3,       
                spaceBetween: 50     
              },     
              1024: {       
                slidesPerView: 5,       
                spaceBetween: 30     
              } 
          }   
        },
        categorii : [], 
        nume_produs : "",
        descriere_produs : "",
        imagine_produs : "",
        external_id: "",
        pret : "",
        alergeni_ro:"",
        alergeni_en:"",
        ingrediente_extra : [],
        produse_favorite : [],
        id_produs : '', 
        count: 1,
        produse_extra: [],
        show : false
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    beforeMount() {
      this.produse_favorite_state = this.$store.state.products_id;
      axios.get('https://xpanel.tikibistro.ro/api/cuisine?t='+Number(new Date()),{ 
          withCredentials: false,
        })
        .then(response => {
            this.categorii = response.data;
        })

    },
    
    mounted () { 
          $('.search_header_mobile').focus( function() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              $('.sectiune_fixa_mobil').hide();
          }
          
          });

          $('.search_header_mobile').blur( function() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              $('.sectiune_fixa_mobil').fadeIn(100);
            }
          });
        $('.search_header_mobile').keypress(function(event){
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                var search_key = $('.search_header_mobile').val();
                window.location.href = '/search?keywords='+search_key;
            }
            event.stopPropagation();
        });
        this.swiper.slideTo(0);

        var that = this;

        $(window).scroll(function() {
            var windscroll = $(window).scrollTop();
            if (windscroll >= 100) {
                $('.padding_text_container').each(function(i) {
                    if ($(this).position().top <= windscroll - 20) {
                        $('.box_categorie.cat_act').removeClass('cat_act');

                        if(!$('.box_categorie').eq(i).hasClass('cat_act'))
                        {
                          $('.box_categorie').eq(i).addClass('cat_act'); 

                         

                          that.swiper.slideTo(getSlideIndexByClass('cat_act'),0);
                         
                          
                        }
                       
                                     
                    }
                });
            } else {
                $('.box_categorie.cat_act').removeClass('cat_act');
                $('.box_categorie:first').addClass('cat_act');
            }
        }).scroll();

      function getSlideIndexByClass(className) {
        var index = 0;
        $.each($('.slic_bucatarie .swiper-wrapper').children(), function(i, item) {
          if ($(item).hasClass(className)) {
            index = i;
            return false;
          }
        });
        return index;
      }

     },
    updated: function () {
      var hash = window.location.hash.substr(1);
      if(hash != '')
      {     
        $("html, body").animate({ scrollTop: $('.'+hash).offset().top - 130 }, 300);
      }
      
    },
    
    filters: {
        strippedContent: function(string) {
              return string.replace(/<\/?[^>]+>/ig, ""); 
        }
    }
  }
</script>


